import { promiseLandConstants } from "../actions/constants/promiseLandConstant";

const promiseLandData = (state = { status: "", message: "" }, action: any) => {
	switch (action.type) {
		case promiseLandConstants.PromiseLand_GetByFilter_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isListSuccess: false,
			};
		case promiseLandConstants.PromiseLand_GetByFilter_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isListSuccess: true,
				items: action.payload,
			};
		case promiseLandConstants.PromiseLand_GetByFilter_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: false,
				status: action.payload,
			};

		case promiseLandConstants.PromiseLandDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case promiseLandConstants.PromiseLandDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				promiseLandInput: action.payload,
			};
		case promiseLandConstants.PromiseLandDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case promiseLandConstants.PromiseLandGetBooksRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case promiseLandConstants.PromiseLandGetBooksSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				bookData: action.payload?.bibleBookData,
			};
		case promiseLandConstants.PromiseLandGetBooksFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case promiseLandConstants.PromiseLandSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				promiseLandInput: action.input,
			};
		case promiseLandConstants.PromiseLandSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
			};
		case promiseLandConstants.PromiseLandSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case promiseLandConstants.PromiseLandDeleteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isDeleteCompleted: false,
			};
		case promiseLandConstants.PromiseLandDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case promiseLandConstants.PromiseLandDeleteFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isDeleteCompleted: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default promiseLandData;
